import { Icon20ChevronLeft, Icon20ChevronRight } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { memo, useMemo } from 'react';

import styles from './contentSlider.css';

interface Props {
    index: number;
    count: number;

    onNextClick(): void;

    onPrevClick(): void;
}

export const ContentSlider = memo(({ index = 0, count, onPrevClick, onNextClick }: Props) => {
    const items = useMemo(() => Array.from({ length: count }, (_, index) => index), [count]);

    return (
        <div className={styles.root}>
            <div className={styles.progress}>
                {items.map((itemId) => (
                    <div key={itemId} className={classNames(styles.item, { [styles.itemFocused]: itemId === index })} />
                ))}
            </div>
            <div className={styles.buttons}>
                <div className={classNames(styles.button, { [styles.buttonDisabled]: index === 0 })} onClick={onPrevClick}>
                    <Icon20ChevronLeft />
                </div>
                <div className={classNames(styles.button, { [styles.buttonDisabled]: index === count - 1 })} onClick={onNextClick}>
                    <Icon20ChevronRight />
                </div>
            </div>
        </div>
    );
});

ContentSlider.displayName = 'ContentSlider';
